import React, { useEffect, useState } from 'react';
import { chatbotService } from '../../services/chatbotService';
import ChatbotSubnav from './ChatbotSubnav';

const ChatbotInstall: React.FC = () => {
  const [snippet, setSnippet] = useState('');
  const [tenantId, setTenantId] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const c = await chatbotService.getConfig();
        if (!cancelled) {
          setSnippet(c.embed_snippet || '');
          setTenantId(c.tenant_id || '');
        }
      } catch (e) {
        if (!cancelled) setError(e instanceof Error ? e.message : 'Failed to load');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(snippet);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setError('Copy failed');
    }
  };

  return (
    <div className="p-6 max-w-3xl">
      <ChatbotSubnav />
      <h1 className="text-2xl font-semibold text-fg mb-2">Install widget</h1>
      <p className="text-sm text-fg-secondary mb-6">
        Paste this snippet before the closing{' '}
        <code className="text-xs bg-surface px-1 rounded">&lt;/body&gt;</code> tag on your site (Wix, WordPress,
        Shopify, Webflow, or plain HTML). It loads the widget from{' '}
        <code className="text-xs bg-surface px-1 rounded break-all">
          https://cdn.launchpointapp.com/static/chatbot/widget.js
        </code>{' '}
        and uses{' '}
        <code className="text-xs bg-surface px-1 rounded">https://launchpointapp.com/api</code> as the API base—copy
        the snippet below as-is unless your deployment uses different URLs.
      </p>
      {loading && <p className="text-fg-secondary">Loading…</p>}
      {error && (
        <div className="mb-4 p-3 rounded-lg bg-red-50 dark:bg-red-900/20 text-red-800 dark:text-red-200 text-sm">
          {error}
        </div>
      )}
      {!loading && tenantId && (
        <div className="bg-surface border border-border rounded-lg p-6 shadow-sm">
          <p className="text-sm text-fg-secondary mb-2">Tenant ID (for reference): {tenantId}</p>
          <div className="relative">
            <pre className="p-4 bg-gray-900 text-gray-100 rounded-lg overflow-x-auto text-xs whitespace-pre-wrap">
              {snippet || 'Save chatbot settings once to generate the embed snippet.'}
            </pre>
            <button
              type="button"
              onClick={copy}
              className="absolute top-2 right-2 px-3 py-1 bg-gray-700 hover:bg-gray-600 text-white text-sm rounded"
            >
              {copied ? 'Copied!' : 'Copy'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatbotInstall;
